import React, { ChangeEvent, FC } from 'react';
import classNames from 'classnames';

import { ToggleSize } from '../../types/Toggle';
import withMouseDownCb, { PreventDefaultMouseDownProps } from '../withMouseDownCbHoc';

import styles from './Toggle.module.scss';

// --

export { ToggleSize };

// --

export type ToggleProps = {
  active: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  name?: string;
  size?: ToggleSize;
};

const ToggleWithoutDownCbHoc: FC<ToggleProps & PreventDefaultMouseDownProps> = ({
  active = false,
  disabled = false,
  size = ToggleSize.LARGE,
  className,
  name,
  onChange,
  onMouseDown,
  ...props
}) => {
  const _className = classNames(
    styles.container,
    styles[`${size}Container`],
    {
      [styles.active]: active,
      [styles.disabled]: disabled,
    },
    className,
  );

  return (
    <div className={_className}
         onMouseDown={onMouseDown}>
      <input type="checkbox"
             name={name}
             disabled={disabled}
             className={styles.input}
             onChange={onChange}
             {...props} />
      <span className={`${styles.button} ${styles[`${size}Button`]}`} />
    </div>
  );
};

export const Toggle = withMouseDownCb(ToggleWithoutDownCbHoc);
